"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

interface LogoItem {
	src: string;
	altKey: string;
}

interface IndustryLogoMarqueeProps {
	namespace: string;
	logos: readonly LogoItem[];
}

export default function IndustryLogoMarquee({ namespace, logos }: IndustryLogoMarqueeProps) {
	const t = useTranslations(namespace);
	const marqueeLogos = [...logos, ...logos];

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="flex flex-col items-center gap-4 border-b border-gray-200 pb-8 sm:gap-5 sm:pb-10 lg:flex-row lg:gap-12 lg:pb-12">
					<div className="flex shrink-0 items-center text-center lg:self-stretch lg:border-r lg:border-gray-200 lg:pr-8 lg:text-left">
						<h2 className="text-xl font-bold text-black sm:text-2xl md:text-[28px] md:leading-tight">
							<span className="block">{t("innovativeTitleLine1")}</span>
							<span className="block">{t("innovativeTitleLine2")}</span>
						</h2>
					</div>

					<div className="relative w-full overflow-hidden py-3 sm:py-4 lg:py-6">
						<div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-8 bg-gradient-to-r from-white to-transparent sm:w-12 lg:w-16" />
						<div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-8 bg-gradient-to-l from-white to-transparent sm:w-12 lg:w-16" />
						<div className="flex animate-scroll-x gap-6 sm:gap-10 md:gap-14 lg:gap-16">
							{marqueeLogos.map((logo, index) => (
								<div
									key={`${logo.src}-${index}`}
									className="flex h-16 w-24 shrink-0 items-center justify-center grayscale transition-all duration-300 hover:grayscale-0 sm:h-20 sm:w-28 md:h-24 md:w-32 lg:h-28 lg:w-36"
								>
									<Image src={logo.src} alt={t(logo.altKey)} width={180} height={96} className="h-full w-full object-contain" />
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
